export const BB_SPORT_SELECTION_CONTAINER_CSS_CLASS_BLOCK_NAME = 'bb-sport-selection-container';
export const BB_SPORT_BETFEED_CSS_CLASS_BLOCK_NAME = 'bb-sport-betfeed-content';
export const BB_SPORT_BETFEED_PRICE_CSS_CLASS = 'bb-sport-betfeed-price';
